// extracted by mini-css-extract-plugin
export default {"modal_container":"RemoveCouponConfirmation_modal_container__Wyo69","confirmationButton":"RemoveCouponConfirmation_confirmationButton__Bd7iy"};